import firebase from './firebase';
import RequestManager from './requestManager';
import { StateManager } from './stateManager';

const BRAND_LABELS = {
  actual: 'Actual Miles',
  not_actual: 'Not Actual',
  exceeds_limits: 'Exceeds Limits',
  exempt: 'Miles Exempt',
};

export const odometerBrandLabel = (brand) => BRAND_LABELS[brand] || '';

// Reads the odometer disclosure off an uploaded title front and writes the
// is_actual / is_exempt / is_excess flags to the car. Leaves the car alone when
// the title shows no readable disclosure. Never throws: the upload already
// succeeded, so a failed read only costs the auto-fill.
export async function applyTitleOdometerBrand(stockNumber, titleFrontPath) {
  if (!stockNumber || !titleFrontPath || /\.pdf$/i.test(titleFrontPath)) return null;
  try {
    const data = await RequestManager.post({ function: 'identifyTitleCar', variables: { imagePath: titleFrontPath } });
    if (!data || !data.success) throw new Error((data && data.message) || 'Title read failed');
    if (!data.odometer_flags) {
      StateManager.setAlertAndOpen('No odometer disclosure found on the title. Set it by hand.', 'info');
      return null;
    }
    await firebase.firestore().doc('cars/' + stockNumber).set(data.odometer_flags, { merge: true });
    if (StateManager.updateCar) StateManager.updateCar(data.odometer_flags);
    StateManager.setAlertAndOpen(`Odometer set from title: ${odometerBrandLabel(data.odometer_brand)}.`, 'success');
    return data.odometer_brand;
  } catch (err) {
    StateManager.setAlertAndOpen(`Could not read the odometer disclosure: ${err.message}`, 'warning');
    return null;
  }
}
